import axiosInstance from "./axiosInstance";

const warehouseService = {
  create: async (payload) => {
    try {
      const response = await axiosInstance.post("/warehouses/create", payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  fetchAll: async () => {
    try {
      const response = await axiosInstance.get("/warehouses/all");
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  fetch: async (id) => {
    try {
      const response = await axiosInstance.get("/warehouses/single/" + id);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  // ✅ FIXED: send startDate/endDate as query params
  fetchStockLedger: async ({ startDate, endDate } = {}) => {
    try {
      const { data } = await axiosInstance.get("/warehouseproducts/stockledger", {
        params: {
          startDate: startDate || undefined,
          endDate: endDate || undefined,
        },
      });
      return data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // ✅ FIXED: also support dates here
  fetchSalesQtyByVendorCode: async (vendor_code, { startDate, endDate } = {}) => {
    try {
      const { data } = await axiosInstance.get(
        "/warehouseproducts/stockledgersales/byvendor",
        {
          params: {
            vendor_code,
            startDate: startDate || undefined,
            endDate: endDate || undefined,
          },
        }
      );
      return data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },

  // ✅ FIXED: also support dates here
  fetchPurchasesQtyByVendorCode: async (vendor_code, { startDate, endDate } = {}) => {
    try {
      const { data } = await axiosInstance.get(
        "/warehouseproducts/stockledgerpurchase/byvendor",
        {
          params: {
            vendor_code,
            startDate: startDate || undefined,
            endDate: endDate || undefined,
          },
        }
      );
      return data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
};

export default warehouseService;
